import {Component, Input} from '@angular/core';
import {EmMarkdownPipe} from '@emma-labs/shared/angular';
import {CardModule} from 'primeng/card';
import {RefusalNoticeInfo} from '../../../entities/archived-proposal-object/refusal-notice-info';

@Component({
  selector: 'em-refusal-notice-section',
  templateUrl: './refusal-notice-section.component.html',
  imports: [CardModule, EmMarkdownPipe],
})
export class RefusalNoticeSectionComponent {
  @Input({required: true}) refusalNoticeInfo!: RefusalNoticeInfo;
}
